import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';

import { MaterialModule } from '@lockton-apps/material';

import { FormFieldModule } from './../form-field/form-field.module';
import { SelectBoxGroupComponent } from './select-box-group/select-box-group.component';
import { SelectBoxComponent } from './select-box.component';
import { SelectBoxContentDirective } from './select-box-content.directive';
import { AvatarModule } from '../avatar';

@NgModule({
  imports: [CommonModule, MaterialModule, FormFieldModule, AvatarModule],
  declarations: [
    SelectBoxComponent,
    SelectBoxGroupComponent,
    SelectBoxContentDirective,
  ],
  exports: [
    SelectBoxComponent,
    SelectBoxGroupComponent,
    SelectBoxContentDirective,
  ],
})
export class SelectBoxModule {}
